<template>
    <v-container fluid pa-0>
        <v-data-table
                dense
                class="app-protection-list-tables elevation-1 mt-3 pt-3 mb-3"
                :headers="headers"
                :items="protectionEntries"
                :items-per-page="-1"
                :hide-default-footer="true"
                item-key="observationArray.id"
                :footer-props="{
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    prevIcon: 'mdi-minus',
                                    nextIcon: 'mdi-plus'
                                  }"
        >
            <template v-slot:item.link="{ item }">
                <a v-if="item.id === 'neomycete' || item.id === 'The Global Fungal Red List'" :href="item.link" :title="$t('title.pdf')" target="_blank"> Link </a>
                <a v-else :href="item.link" :title="$t('title.pdf')" target="_blank"> PDF </a>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>

    import axios from 'axios'
    import i18n from '../../plugins/i18n'
    import {speciesUrl} from '../../data/app-data'
    import {API_ERROR_MESSAGE} from '../../data/constants'

    export default {
        name: 'ProtectionStatus',

        data() {
            return {
                headers: [
                    {text: i18n.t('statistics.tableListe'), align: 'left', value: 'list'},
                    {text: i18n.t('statistics.tableLink'), align: 'left', value: 'link'},
                    // {text: i18n.t('statistics.tableRL'), align: 'left', value: 'redlist'},
                    {text: i18n.t('statistics.tableProtection'), align: 'left', value: 'status'},
                    {text: i18n.t('statistics.tableAbbreviation'), align: 'left', value: 'abbreviation'},
                ],
                protectionEntries: [],
            }
        },

        computed: {
            taxonId() {
                return this.$store.state.taxonId
            },
            isFungusApp() {
                return this.$store.getters.isFungusApp
            },
            protectionAPI() {
                return this.isFungusApp ? speciesUrl.protectionFungus : speciesUrl.protectionLichen
            },
        },

        watch: {
            taxonId() {
                this.$store.commit('setReliableDataBasis', false)
                this.getProtectionInformation()
            }
        },

        methods: {

            getProtectionInformation() {
                if (this.taxonId !== null) {
                    this.protectionEntries = []

                    axios.get(this.protectionAPI + this.taxonId).then((result) => {

                        // select the correct info sheet
                        if (this.$store.state.lang === 'fr') {
                          this.protectionResult = result.data.filter(x => x.lang === 'F' || x.lang === null)
                        } else if (this.$store.state.lang === 'it') {
                          this.protectionResult = result.data.filter(x => x.lang === 'I' || x.lang === null)
                        } else { // for german and english
                          this.protectionResult = result.data.filter(x => x.lang === 'D' || x.lang === null)
                        }

                        for (let i = 0; i < this.protectionResult.length; i++) {
                            this.protectionEntries.push({
                                id: this.protectionResult[i].listName,
                                list: this.protectionResult[i].listName,
                                link: this.protectionResult[i].listUrl,
                                // redlist: this.protectionResult[i].redlistSpecies,
                                status: this.protectionResult[i].endangeredStatus === null ? i18n.t('general.noData') : this.protectionResult[i].endangeredStatus,
                                abbreviation: this.protectionResult[i].endangeredAbbreviation === null ? i18n.t('general.noData') : this.protectionResult[i].endangeredAbbreviation,
                            })
                        }

                        if (this.isFungusApp) {
                            axios.get(speciesUrl.isNeomycete + this.taxonId).then((result) => {
                                this.$store.commit('setNeomyceteStatus', result.data[0].neomycete)
                                this.protectionEntries.push({
                                    id: 'neomycete',
                                    list: i18n.t('statistics.titleNeomycete'),
                                    link: 'https://swissfungi.wsl.ch/de/neomyceten.html',
                                    redlist: '',
                                    status: this.$store.state.neomyceteStatus === '/' ? i18n.t('general.noData') : this.$store.state.neomyceteStatus,
                                    abbreviation: ''
                                })

                            }).catch((error) => {
                                this.$store.commit('setNeomyceteStatus', '/')
                                console.log(API_ERROR_MESSAGE, error)
                            })
                        }
                    }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                        this.$store.commit('setReliableDataBasis', false)
                        this.$store.commit('setTotalListEntries', 0)
                    })

                } else {
                    this.$store.commit('setReliableDataBasis', false)
                    this.$store.commit('setTotalListEntries', 0)

                }
            }

        },

        created() {
            this.getProtectionInformation()
        }
    }
</script>

<style scoped>

    /* set to nowrap to avoid shrinking of table headers, see also: https://github.com/vuetifyjs/vuetify/issues/10164*/
    /* use /deep/ and parent vuetify class to only modify table header but not the table rows (especially for mobile view) */
    .app-protection-list-tables /deep/ .v-data-table-header {
        white-space: nowrap !important;
    }

</style>